module.exports = __webpack_public_path__ + "assets/img/12306.cf71c4f6.png";